import defaultTheme from '../../Template/theme'
import components from './components'
const theme = {
  ...defaultTheme,
  components
}

export {theme}
export default theme



// WEBPACK FOOTER //
// ./src/app/configuration/TargetRetailWalmart/theme/index.js